import React, { SVGProps } from 'react'

const InfoCircle = (props?: SVGProps<SVGSVGElement>) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.74967 0.333374C3.07367 0.333374 0.0830078 3.32404 0.0830078 7.00004C0.0830078 10.676 3.07367 13.6667 6.74967 13.6667C10.4257 13.6667 13.4163 10.676 13.4163 7.00004C13.4163 3.32404 10.4257 0.333374 6.74967 0.333374ZM6.74967 12.3334C3.80901 12.3334 1.41634 9.94071 1.41634 7.00004C1.41634 4.05937 3.80901 1.66671 6.74967 1.66671C9.69034 1.66671 12.083 4.05937 12.083 7.00004C12.083 9.94071 9.69034 12.3334 6.74967 12.3334Z"
      fill="#68707C"
    />
    <path
      d="M6.08301 6.33329H7.41634V10.3333H6.08301V6.33329ZM6.08301 3.66663H7.41634V4.99996H6.08301V3.66663Z"
      fill="#68707C"
    />
  </svg>
)

export default InfoCircle
